import TemplateView from '../../../../../../js/TemplateView'
import Button from '../../../../../../js/components/Button'
import messageResource from '../../../../../../js/messageResource'

export default class ExportICalLightBoxFooter extends TemplateView {
    constructor({
        onGetFileButtonClick = () => {},
        onCancelButtonClick = () => {},
    } = {}) {
        super()

        this.state = {
            getFileButtonEnabled: false,
            loading: false,
        }

        this.callbacks = {
            onGetFileButtonClick,
            onCancelButtonClick,
        }

        this.onStatePropertyChanged('getFileButtonEnabled', getFileButtonEnabled => this.getFileButton.setState({disabled: !getFileButtonEnabled}))
        this.onStatePropertyChanged('loading', loading => this.getFileButton.setState({loading}))
    }

    templateHtml() {
        return `<div class='basicLightboxFooter'>
                    <div class='buttonsBox'>
                        <div class='getFileButton'/>
                        <div class='cancelBtn'>
                            <%=cancelButtonLabel%>
                        </div>
                    </div>
                </div>`
    }

    messageKeys() {
        return {
            cancelButtonLabel: 'common.cancel'
        }
    }

    afterRender() {
        this.getFileButton = new Button({
            label: messageResource.getMessage('icalendar.page.lightbox.button.get'),
            onClickCb: this.callbacks.onGetFileButtonClick,
            withLoading: true,
        }).init(this.find('.getFileButton'))

        this.$cancelButtonEl = this.find('.cancelBtn')
    }

    //for compatibility with LightBox
    getCommitBtnEl() {
        return []
    }

    //for compatibility with LightBox
    getCancelBtnEl() {
        return this.$cancelButtonEl
    }
}



// WEBPACK FOOTER //
// ./web/actiplans/js/icalendar/components/lightbox/export/ExportICalLightBoxFooter.js